import { SubnavigationButton } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { useRef } from 'react';
import styles from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/MultiTariffsListMobile.css';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

interface ScrollableTabItemProps {
    value: ETabsName;
    text: string;
    activeTariffTab?: ETabsName;
    onClick: () => void;
}

export function ScrollableTabItem({ text, value, activeTariffTab, onClick }: ScrollableTabItemProps) {
    const ref = useRef<HTMLDivElement>(null);
    const selected = value === activeTariffTab;

    return (
        <SubnavigationButton
            getRootRef={ref}
            size="l"
            className={classNames(styles.scrollable_tabs_item, {
                [styles.scrollable_tabs_item_selected]: selected,
            })}
            value={value}
            selected={selected}
            onClick={() => {
                requestAnimationFrame(() => ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }));
                onClick();
            }}
        >
            {text}
        </SubnavigationButton>
    );
}
